// Module
var code = "<div flex ui-view layout-fill layout=\"column\"></div> ";
// Exports
module.exports = code;